import React, { Component, memo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changeCurrency, changeSide } from "../redux/actions/currenciesActions";
import { getCurrencyWalletInfo } from "../services/rashTradeServices";
import { currencies } from "../staticData/currencies";
import { toFixed } from "../utils/common-functions";
import { connectionClass } from "../websocket/socket";
import SelectInput from "./common-components/SelectInput";

const MainBoxHeader = () => {
    const { currentCurrencyId, currentSide, currenciesList, isDarkMode } = useSelector((state) => {
        return state.persistedReducer;
    });
    const currentCurrency = currenciesList[currentCurrencyId];
    const {
        operations: { isRenkoCreationOn, isModelOn, isBinanceOn },
        marketPrice,
        decimalNumber
    } = currentCurrencyId && currenciesList[currentCurrencyId];
    const dispatch = useDispatch();
    return (
        <div className="min-w-24 z-20 w-full flex justify-around flex-col md:flex-row">
            {[
                {
                    inputFunction: (value) => {
                        dispatch(changeCurrency(value.currencyId));
                    },

                    inputVarName: "currencyDesc",
                    inputList: Object.values(currenciesList).sort((a, b) =>
                        a.currencySymbol.localeCompare(b.currencySymbol, undefined, { sensitivity: "base" })
                    ).map((currency, index) => {
                        const {
                            currencySymbol,
                            operations: { isRenkoCreationOn, isModelOn, isBinanceOn },
                            marketPrice
                        } = currency;

                        return {
                            ...currency,
                            currencyDesc: `${index + 1}. (${marketPrice || 0}) | ${currencySymbol ?? currency?.symbolInfo?.symbol
                                } | ${isRenkoCreationOn ? "✓" : "x"} ${isModelOn ? "✓" : "x"} ${isBinanceOn ? "✓" : "x"
                                }`
                        };
                    }),
                    defaultText: `(${toFixed(marketPrice, decimalNumber || 5)}) | ${currentCurrency.currencyDesc
                        } | ${isRenkoCreationOn ? "✓" : "x"} ${isModelOn ? "✓" : "x"} ${isBinanceOn ? "✓" : "x"
                        }`,
                    isEditable: true
                },
                {
                    inputFunction: (value) => {
                        dispatch(changeSide(value));
                    },

                    inputVarName: "sideLabel",
                    inputList: [
                        {
                            side: "BUY",
                            sideLabel: "BUY",
                            value: "BUY"
                        },
                        {
                            side: "SELL",
                            sideLabel: "SELL",
                            value: "SELL"
                        },
                        {
                            side: "BUY",
                            sideLabel: "BUY & SELL",
                            value: "TOGETHER"
                        }
                    ],
                    defaultText: currentSide.sideLabel,
                    isEditable: true
                }
            ].map((selectBtn, index) => {
                let selectInputLabel = <div>{selectBtn.defaultText}</div>;
                return (
                    <SelectInput
                        key={index}
                        selectFunction={(value) => {
                            selectBtn.inputFunction(value);
                        }}
                        selectHolder={{
                            styles: {},
                            className:
                                " flex min-h-7  py-3  min-w-24 rounded-lg md:min-h-9 md:min-w-24  "
                        }}
                        selectOptions={{
                            holderStyle: {},
                            className: "flex justify-center relative  w-full ",
                            selectedValue: {
                                defaultText: selectInputLabel,
                                style: {},
                                className: `${isDarkMode ? "bg-primaryDark " : "bg-primaryLight "
                                    }  min-h-7   flex justify-center items-center cursor-pointer text-vsm w-full`
                            },
                            list: {
                                holderStyle: {},
                                className: `absolute top-10  max-h-64  secondaryScroll w-full z-12 ${isDarkMode ? "bg-primaryDark " : "bg-tertiaryLight "
                                    } ${index == 0 && "overflow-y-scroll"}  `,
                                options: selectBtn.inputList,
                                singleOption: {
                                    divStyle: {
                                        zIndex: 70
                                    },
                                    divClassName: `   min-w-20 mb-2 min-h-7  primaryBoxShadow flex items-center justify-center cursor-pointer w-full `,
                                    labelStyle: {
                                        cursor: "pointer",
                                        fontSize: 10,
                                        width: "100%",
                                        height: "100%"
                                    },
                                    labelClassName:
                                        "  flex items-center justify-center cursor-pointer w-full",
                                    inputStyle: {
                                        display: "none"
                                    }
                                }
                            }
                        }}
                        optionName={selectBtn.inputVarName}
                        isEditable={selectBtn.isEditable}
                    />
                );
            })}
        </div>
    );
};

export default MainBoxHeader;
